module.exports = "<p>\r\n  customers works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/customers.component.html
// module id = ./src/app/customers/customers.component.html
// module chunks = main